// extracted by mini-css-extract-plugin
export var csatScore = "_kc-5";
export var header = "_kc-1";
export var panelWrapper = "_kc-2";
export var postPreview = "_kc-3";
export var rightContent = "_kc-0";
export var wrappingText = "_kc-4";